<template lang="pug">
  div
    v-overlay(
      :value="isTemporary"
      @click="closeDrawer()"
    )
    v-navigation-drawer(
      :value="$store.state.drawer || mini"
      :mini-variant="mini"
      disable-resize-watcher
      stateless
      :temporary="isTemporary"
      hide-overlay
      app
      floating
      :color="dark ? 'secondary' : 'white'"
      :dark="dark"
      width="300"
      mini-variant-width="64"
      @input="onInput"
    ).app-drawer
      .fill-height.scroll-light.overflow-auto
        router-link(to="/")
          v-img.my-2.ml-4(
            :src="require(`@/assets/logo${mini ? '' : (dark ? '-white' : '-dark')}.svg?inline`)"
            height="50"
            contain
            position="left center"
          )
        //- v-list-item(
        //-   v-else
        //-   to="/"
        //- )
        //-   new-year-logo

        permissions-wrapper(
          :roles="[$conf.ROLES.teacher]"
          v-slot:default
        )
          .d-flex.flex-column.pa-2.mb-3(v-if="!mini")
            div
              v-btn.justify-start(
                :light="dark" text block
                :color="$user.studentMode ? 'primary' : 'secondary'"
                @click="$store.dispatch('auth/SET_STUDENT_MODE', true); onChangedMode()"
              )
                v-icon(left size="24").mr-4 mdi-school-outline
                | {{ $user.studentMode ? 'Я обучаюсь' : 'Обучаться'}}

            div
              v-btn.mt-2.justify-start(
                color="white" text block
                :light="dark"
                :color="!$user.studentMode ? 'primary' : 'secondary'"
                @click="$store.dispatch('auth/SET_STUDENT_MODE', false); onChangedMode()"
              )
                v-icon(left size="24").mr-4 mdi-book-open-blank-variant-outline
                | {{ $user.studentMode ? 'Преподавать' : 'Я преподаю'}}

        v-list(:dark="dark").ma-2
          v-list-item(
            v-if="showDesktop"
            :to="{ name: 'Desktop' }"
          )
            v-list-item-icon(:class="listItemIconClasses")
              v-icon(:color="dark ? 'white' : 'secondary'") mdi-laptop
            v-list-item-content
              v-list-item-title Рабочий стол
          template(v-for="category in navItems" v-if="category.category_name")
            v-list-item(v-if="!mini" :key="category.category_name")
              v-list-item-content
                v-list-item-subtitle.text-uppercase {{ category.category_name }}

            template(v-for="(item, idx) in category.items")
              v-menu(
                :key="category.category_name + idx + mini"
                :dark="!dark"
                open-on-hover
                offset-x
                nudge-right="9"
                close-delay="100"
              )
                template(v-slot:activator="{ on, attrs }")
                  v-list-group(
                    v-if="item.isGroup && !mini"
                    v-bind="attrs"
                    v-on="mini && on"
                    class="menu-item list-group"
                    :class="{ 'has-active-child': item.hasActiveChild }"
                    :prepend-icon="item.icon"
                  )
                    template(v-slot:activator)
                      v-list-item-title(class="my-4") {{ item.title }}
                    v-list-item(
                      v-for="child in item.children"
                      :key="child.title"
                      :to="child.route"
                      class="ml-4"
                      exact
                      link
                    )
                      v-list-item-icon(:class="listItemIconClasses")
                        v-icon {{ child.icon }}
                      v-list-item-content
                        v-list-item-title {{ child.title }}
                  v-list-item(
                    v-else
                    v-bind="attrs"
                    v-on="mini && on"
                    :to="item.route"
                    link
                    :class="{ 'has-active-child': item.hasActiveChild }"
                    :key="category.category_name + idx + mini"
                  ).mb-1
                    v-list-item-icon(:class="listItemIconClasses")
                      v-icon(:color="dark ? 'white' : 'secondary'") {{ item.icon }}
                    v-list-item-content
                      v-badge(
                        :value="item.badge ? $store.state.messages[item.badge.key] : false"
                        overlap dot color="error" offset-x="12"
                      )
                        v-list-item-title {{ item.title }}
                v-card
                  v-list.pa-0(color="secondary")
                    v-list-item(
                      :to="item.route"
                    )
                      v-list-item-content
                        v-list-item-title {{ item.title }}
                  v-list.pa-0(v-if="item.isGroup")
                    v-list-item(
                      v-for="child in item.children"
                      :key="child.title"
                      :to="child.route"
                      exact
                    )
                      v-list-item-icon(:class="listItemIconClasses")
                        v-icon {{ child.icon }}
                      v-list-item-content
                        v-list-item-title {{ child.title }}

      template(v-slot:append)
        template(v-if="!mini")
          v-list-item(
            v-show="false"
            class="menu-item py-1"
          )
            v-list-item-content.pa-0
              v-list-item-title
                v-select(
                  :value="userData.role"
                  :items="userResources.user_role"
                  item-text="title"
                  item-value="value"
                  label="Роль"
                  hint="Тестовое изменение роли"
                  :persistent-hint="true"
                  solo
                  @change="switchRole($event)"
                )
          //- v-list-item(
          //-   class="menu-item py-1"
          //- )
          //-   v-list-item-content.pa-0
          //-     v-list-item-title
          //-       v-switch(
          //-         :value="$vuetify.theme.dark"
          //-         label="Темная тема"
          //-         @change="switchDarkTheme($event)"
          //-       )
        v-list-item(
          @click="toggleDrawer()"
          dense
        )
          v-icon {{ mini ? 'mdi-arrow-right' : 'mdi-arrow-left' }}
          v-list-item-content.ml-2
            v-list-item-title Свернуть
</template>

<script>
import { VListGroup } from 'vuetify/lib';
import { mapGetters, mapMutations } from 'vuex';
// import { utcToZonedTime, format } from 'date-fns-tz';

import { getRoleName } from '@/modules/Auth/constants';
// import SetTimezoneDialog from '@/modules/UserSettings/components/SetTimezoneDialog.vue';
import NewYearLogo from '@/assets/pfdo-new-year.vue';

import { NAV_ITEMS } from './nav-items';

const NEW_YEAR_DAY_OFFSETS = {
  december: 14,
  january: 15,
};
export default {
  name: 'NavigationDrawer',
  components: {
    NewYearLogo,
    // SetTimezoneDialog,
    VListGroup,
  },
  data: () => ({
    isNewYearLogo: false,
    version: process.env.VERSION,
    timezoneDialog: false,
    // currentTime: '',
    intervalId: null,
    mini: false,
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
      userResources: 'userResources',
      messages: 'auth/getMessages',
    }),
    showDesktop() {
      const { organization, operator } = this.$conf.ROLES;
      return ![organization.value, operator.value].includes(this.userData.role);
    },
    listItemIconClasses() {
      return {
        'mr-4': !this.mini,
        'menu-item__icon': true,
      };
    },
    dark() {
      return false || this.$vuetify.theme.dark;
    },
    isMobile() {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    navItems() {
      let { role } = this.$user.data;
      if (this.$user.studentMode) {
        role = this.$conf.ROLES.student.value;
      }
      return NAV_ITEMS.reduce((acc, value) => {
        const filteredItems = value.items.filter(
          (i) => {
            if (i.roles) {
              return i.roles.map((r) => r.value).includes(role)
              || (this.$user.isOrganization
                && i.roles.map((r) => r.value).includes(this.$user.orgRole));
            }
            return true;
          },
        );
        let filteredCategory;
        if (!value.roles || value.roles.map((i) => i.value).includes(role)) {
          filteredCategory = {
            ...value,
            items: this.filterRoles(filteredItems, 'children'),
          };
          acc.push(filteredCategory);
        }
        return acc;
      }, []);
    },
    isTemporary() {
      return this.$store.state.drawer && !this.mini && this.isMobile;
    },
  },
  watch: {
    isMobile(val) {
      if (!val) this.mini = true;
      else this.mini = false;
      this.$store.dispatch('SET_DRAWER', false);
    },
    $route() {
      this.mini = this.$route.meta.mini;

      if (this.isTemporary) {
        this.closeDrawer();
      }
    },
  },
  created() {
    this.getUnreadMessages();

    if (!this.isMobile) {
      this.$store.dispatch('SET_DRAWER', true);
    }
    const date = new Date();
    const currentMonth = date.getMonth() + 1;
    const currentDay = date.getDate();

    if (
      (currentMonth === 12 && currentDay >= NEW_YEAR_DAY_OFFSETS.december)
      || (currentMonth === 1 && currentDay <= NEW_YEAR_DAY_OFFSETS.january)
    ) this.isNewYearLogo = true;
  },
  methods: {
    getUnreadMessages() {
      const items = this.navItems.map((i) => i.items).flat().filter((i) => i.badge);
      if (items.length) {
        items.forEach((i) => this.$store.dispatch(i.badge.dispatchMethod));
      }
    },

    ...mapMutations({
      SET_ROLE: 'auth/SET_ROLE',
      SET_DARK_THEME: 'SET_DARK_THEME',
    }),
    onChangedMode() {
      this.$router.push('/desktop');
    },
    onInput(val) {
      if (!val && !this.isMobile) {
        this.mini = true;
      }
    },
    toggleDrawer() {
      if ((this.mini && !this.isMobile) || this.isTemporary) return this.closeDrawer();
      return this.showDrawer();
    },
    showDrawer() {
      if (this.isMobile) {
        this.$store.dispatch('SET_DRAWER', true);
        this.mini = false;
      } else {
        this.$store.dispatch('SET_DRAWER', false);
        this.mini = true;
      }
    },
    closeDrawer() {
      if (this.isMobile) {
        this.$store.dispatch('SET_DRAWER', false);
        this.mini = false;
      } else {
        this.$store.dispatch('SET_DRAWER', true);
        this.mini = false;
      }
    },
    filterRoles(items, fieldNameItems) {
      return items.reduce(
        (acc, value) => ([
          ...acc,
          {
            ...value,
            hasActiveChild: value.children && value.children
              .find((i) => i.route.name === this.$route.name),

            [fieldNameItems]: value[fieldNameItems] ? value[fieldNameItems].filter(
              (i) => (i.roles ? i.roles.map((r) => r.value).includes(this.userData.role) : true),
            ) : [],
          }]
        ), [],
      );
    },
    switchDarkTheme(val) {
      this.SET_DARK_THEME(val);
    },
    switchRole(role) {
      this.SET_ROLE(role);
    },
    // setCurrentTime() {
    //   const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    //   const zonedDate = utcToZonedTime(new Date(), timeZone);
    //   this.currentTime = format(zonedDate, 'HH:mm:ss');
    // },
    getRoleName,
  },
};
</script>

<style lang="scss" scoped>
  .v-list-item::after {
    content: none;
  }

  .v-list-item__title {
    font-size: 0.9rem!important;
    font-weight: 700!important;
  }

  .menu-item {
    /*flex-direction: column;*/
    opacity: 1;
  }

  ::v-deep .v-list-item__icon.v-list-group__header__prepend-icon {
    margin-right: 16px;
  }
</style>
